export const PROVIDER_ENTITY_ATTRIBUTE_STATUS = {
  SYNCED: 'SYNCED',
  DELETED: 'DELETED',
  TO_CREATE: 'TO_CREATE',
  TO_UPDATE: 'TO_UPDATE',
  TO_DELETE: 'TO_DELETE',
  DO_NOTHING: 'DO_NOTHING',
};
